const convertToDMS = (coordinate) => {
  const isNegative = coordinate < 0;
  const truncate = isNegative ? Math.ceil : Math.floor;
  const degrees = truncate(coordinate);
  const minutes = Math.floor(60 * Math.abs(coordinate - degrees));
  const seconds = (
    3600 * Math.abs(coordinate - degrees) -
    60 * minutes
  ).toFixed(4);

  return {
    degrees,
    minutes,
    seconds,
    isNegative,
  };
};

export const displayLatitudeInDMS = (latitude) => {
  const DMS = convertToDMS(latitude);
  return `${Math.abs(DMS.degrees)}\xB0 ${DMS.minutes}' ${DMS.seconds}" ${
    DMS.isNegative ? 'S' : 'N'
  }`;
};

export const displayLongitudeInDMS = (longitude) => {
  const DMS = convertToDMS(longitude);
  return `${Math.abs(DMS.degrees)}\xB0 ${DMS.minutes}' ${DMS.seconds}" ${
    DMS.isNegative ? 'W' : 'E'
  }`;
};

export const displayLatitudeInDDM = (latitude) => {
  const DMS = convertToDMS(latitude);
  return `${Math.abs(DMS.degrees)}\xB0 ${(
    DMS.minutes +
    DMS.seconds / 60
  ).toFixed(4)}' ${DMS.isNegative ? 'S' : 'N'}`;
};

export const displayLongitudeInDDM = (longitude) => {
  const DMS = convertToDMS(longitude);

  return `${Math.abs(DMS.degrees)}\xB0 ${(
    DMS.minutes +
    DMS.seconds / 60
  ).toFixed(4)}' ${DMS.isNegative ? 'W' : 'E'}`;
};

export const formatLatLon = (coordinateSystem, latitude, longitude) => {
  switch (coordinateSystem) {
    case 'degreesDecimalMinutes':
      return `${displayLatitudeInDDM(latitude)}, ${displayLongitudeInDDM(
        longitude,
      )}`;
    case 'degreesMinutesSeconds':
      return `${displayLatitudeInDMS(latitude)}, ${displayLongitudeInDMS(
        longitude,
      )}`;
    default:
      return `${latitude.toFixed(4)}, ${longitude.toFixed(4)}`;
  }
};
